import React from 'react'
import { useLocation, Navigate } from 'react-router-dom'
import { useRecoilValue } from 'recoil'
import { authenticated } from '../recoil/auth';

const Guest = (props) => {
    const auth = useRecoilValue(authenticated);
    const location = useLocation();

    if (auth.check) {
        return <Navigate to="/" state={{ from: location }} />
    }
    return props.render;
};

export default Guest